export enum OrderStatusesEnum {
  NEW = 'created',
  ACCEPTED = 'accepted',
  CONFIRMED = 'confirmed',
  PACKING = 'packing',
  PACKED = 'packed',
  DELIVERING = 'delivering',
  WAIT_RECEIPT = 'wait_receipt',
  DELIVERED = 'delivered',
  RECEIVED = 'received',
  PART_RECEIVED = 'part_received',
  CANCELED = 'canceled'
}

export const localizedOrderStatuses = {
  [OrderStatusesEnum.NEW]: 'Новый',
  [OrderStatusesEnum.ACCEPTED]: 'Принят',
  [OrderStatusesEnum.CONFIRMED]: 'Подтвержден',
  [OrderStatusesEnum.PACKING]: 'Упаковывается',
  [OrderStatusesEnum.PACKED]: 'Упакован',
  [OrderStatusesEnum.DELIVERING]: 'Доставляется',
  [OrderStatusesEnum.WAIT_RECEIPT]: 'Ожидает получения',
  [OrderStatusesEnum.DELIVERED]: 'Доставлен',
  [OrderStatusesEnum.RECEIVED]: 'Получен',
  [OrderStatusesEnum.PART_RECEIVED]: 'Частично получен',
  [OrderStatusesEnum.CANCELED]: 'Отменен'
};

export const statusStyles = {
  [OrderStatusesEnum.NEW]: {
    color: '#1b9c97',
    backgroundColor: '#e6f0ef',
    borderColor: 'none'
  },
  [OrderStatusesEnum.ACCEPTED]: {
    color: 'white',
    backgroundColor: '#1aab71',
    borderColor: 'none'
  },
  [OrderStatusesEnum.CONFIRMED]: {
    color: 'white',
    backgroundColor: '#1a6ebd',
    borderColor: 'none'
  },
  [OrderStatusesEnum.PACKING]: {
    color: '#e69b3e',
    backgroundColor: '#ede4d8',
    borderColor: 'none'
  },
  [OrderStatusesEnum.PACKED]: {
    color: '#a926d1',
    backgroundColor: '#efe6f0',
    borderColor: 'none'
  },
  [OrderStatusesEnum.DELIVERING]: {
    color: 'white',
    backgroundColor: 'teal',
    borderColor: 'teal'
  },
  [OrderStatusesEnum.WAIT_RECEIPT]: {
    color: '#6c7878',
    backgroundColor: '#d5d8d8',
    borderColor: 'none'
  },
  [OrderStatusesEnum.DELIVERED]: {
    color: 'white',
    backgroundColor: '#27a579',
    borderColor: 'none'
  },
  [OrderStatusesEnum.RECEIVED]: {
    color: '#46b0e0',
    backgroundColor: '#dae7ed',
    borderColor: 'none'
  },
  [OrderStatusesEnum.PART_RECEIVED]: {
    color: 'black',
    backgroundColor: 'white',
    borderColor: 'black'
  },
  [OrderStatusesEnum.CANCELED]: {
    color: '#d63230',
    backgroundColor: '#fae7e6',
    borderColor: 'none'
  }
};
